import { render, staticRenderFns } from "./orderDatalis.vue?vue&type=template&id=02cec952&scoped=true"
import script from "./orderDatalis.vue?vue&type=script&lang=js"
export * from "./orderDatalis.vue?vue&type=script&lang=js"
import style0 from "./orderDatalis.vue?vue&type=style&index=0&id=02cec952&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cec952",
  null
  
)

export default component.exports